'use client'
import { ComingUpTimeline } from '@repo/dashboard/ComingUpTimeline'
import { DashboardChart } from '@repo/dashboard/DashboardChart'
import { DashboardHeader } from '@repo/dashboard/DashboardHeader'
import { DashboardNews } from '@repo/dashboard/DashboardNews'
import { DashboardPanel } from '@repo/dashboard/DashboardPanel'
import { MatterList } from '@repo/ui/MatterList'
import { ThirdPartyNotification } from '@repo/dashboard/ThirdPartyNotification'
import { useEffect, useState } from 'react'
import { useFeeEarnerStore } from '@repo/store/useFeeEarnerStore'
import { useMattersStore } from '@repo/store/useMattersStore'
import { useNotificationStore } from '@repo/store/useNotificationStore'
import MUIButton from '@mui/material/Button'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const DashboardModule = ({ testMode = false }) => {
  const { recentMatters, fetchRecentMatters } = useMattersStore()
  const { fetchFeeEarners } = useFeeEarnerStore()
  const { fetchAllNotifications, allNotifications, setNotificationSourceId, setNotificationTypeId } =
    useNotificationStore()

  const [notificationsOpen, setNotificationsOpen] = useState(false)

  useEffect(() => {
    if (testMode) return
    fetchRecentMatters()
    fetchFeeEarners()
  }, [testMode, fetchRecentMatters, fetchFeeEarners])

  useEffect(() => {
    if (testMode) return

    setNotificationsOpen(false)

    const getAllNotifications = async () => {
      setNotificationTypeId('NEWMATTER')
      setNotificationSourceId('PERFECTPORTAL')

      await fetchAllNotifications({
        notificationStatusIds: 'OPEN',
        startAtIndex: 0,
        pageSize: 25
      })
    }

    setTimeout(() => {
      getAllNotifications()
    }, 1000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchAllNotifications, testMode])

  useEffect(() => {
    allNotifications &&
      allNotifications.totalRowCount > 0 &&
      allNotifications.status !== 204 &&
      setNotificationsOpen(true)
  }, [allNotifications])

  return (
    <MUIStack
      direction="column"
      sx={{ width: '100%', maxWidth: '1440px', margin: '70px auto 0', padding: '24px 40px 40px' }}
      gap={'24px'}
    >
      <ThirdPartyNotification open={notificationsOpen} />
      <DashboardHeader />
      <MUIStack direction="row" alignItems="stretch" justifyContent="center" gap={'24px'} sx={{ width: '100%' }}>
        <MUIStack
          direction="column"
          alignItems="center"
          justifyContent="flex-start"
          gap={'24px'}
          sx={{ width: `${100 * (8 / 12)}%` }}
        >
          <ComingUpTimeline />
          <DashboardChart />
        </MUIStack>

        <MUIStack
          direction="column"
          alignItems="center"
          justifyContent="flex-start"
          gap={'24px'}
          sx={{ width: `${100 * (4 / 12)}%` }}
        >
          <DashboardPanel title="Recent matters" variant="small">
            <MatterList matters={recentMatters} maxHeight="360px" isEmpty={!recentMatters?.length} />
          </DashboardPanel>

          <DashboardPanel title="News" variant="small">
            <DashboardNews />
          </DashboardPanel>

          <DashboardPanel title="Tell us what you think!" variant="small">
            <MUIStack direction="column" sx={{ width: '100%', padding: '24px 16px 40px' }} gap={'24px'}>
              <MUITypography variant="body1">
                {`We'd love to hear your feedback on the new updates to Osprey Approach.

                  Please take a moment to let us know your thoughts so we can focus on the areas that matter most to you.`}
              </MUITypography>

              <MUIButton
                onClick={() =>
                  window.open('mailto:support@ospreyapproach.com?subject=Feedback%20on%20Osprey%20Approach', '_blank')
                }
                variant="contained"
                size="large"
              >
                Provide feedback
              </MUIButton>
            </MUIStack>
          </DashboardPanel>
        </MUIStack>
      </MUIStack>
    </MUIStack>
  )
}

DashboardModule.propTypes = {
  testMode: PropTypes.bool
}
